import { Controller } from '@hotwired/stimulus'

export default class QualificationStepController extends Controller {
  static targets = [ "informedConfirmation", "documents", "question", "acceptanceCheckboxes" ]
  static values = { questionsToAnswer: Number, questionsToBeInformed: Number }

  countPositiveAnswers(_event) {
    if (!this.#allQuestionsAnswered()) return;

    const positiveAnswers = this.questionTargets.filter((question) => {
      return question.value === "true" && question.checked
    }).length

    if (positiveAnswers >= this.questionsToBeInformedValue) {
      this.informedConfirmationTarget.classList.remove("d-none")
      this.acceptanceCheckboxesTarget.classList.add("d-none");
    } else {
      this.informedConfirmationTarget.classList.add("d-none");
      this.acceptanceCheckboxesTarget.classList.remove("d-none");
      this.documentsTarget.classList.add("d-none");
    }
  }

  displayDocumentsAndAcceptanceCheckboxes(event) {
    const wantsToBeConsideredInformed = (event.target.value === "accepts_to_be_considered_informed");

    if (wantsToBeConsideredInformed) {
      this.documentsTarget.classList.remove("d-none")
    } else {
      this.documentsTarget.classList.add("d-none")
    }

    this.acceptanceCheckboxesTarget.classList.remove("d-none");
  }

  #allQuestionsAnswered() {
    const answeredQuestions = this.questionTargets.filter((question) => {
      return question.checked
    }).length

    return answeredQuestions === this.questionsToAnswerValue;
  }
}
